<!-- gmail-mobile-04 preview — Gmail inbox, ad row with the landscape creative under the copy -->
<app-mobile-frame>
  <div frameTop class="gm-inbox-topbar">
    <div class="gm-inbox-searchbar d-flex flex-row align-items-center justify-content-between">
      <i class="bi bi-list gm-inbox-icon"></i>
      <span class="gm-inbox-avatar placeholder"></span>
    </div>
  </div>

  <div class="gm-inbox">
    <div class="gm-inbox-tabs">
      <span class="gm-inbox-tab-bar placeholder"></span>
    </div>

    <!-- START: Real ad -->
    <div class="gm-inbox-ad d-flex flex-row">
      <span class="gm-inbox-logo gm-letter-avatar" aria-hidden="true">V</span>

      <div class="gm-inbox-copy">
        <div class="gm-inbox-line1">
          <span class="gm-inbox-sponsored">Sponsored</span> ·
          <span class="gm-inbox-sender">Valamar</span>
        </div>
        <a [href]="data.url || null" target="_blank" rel="noopener noreferrer" class="gm-inbox-headline">
          {{ data.headlines[0] || "Your headline appears here" }}
        </a>
        <div class="gm-inbox-desc">
          {{ data.descriptions[0] || "Your description appears here" }}
        </div>
        <a [href]="data.url || null" target="_blank" rel="noopener noreferrer" class="gm-inbox-creative-link">
          <img *ngIf="creativeImage" class="gm-inbox-creative" [src]="creativeImage" alt="" />
          <div *ngIf="!creativeImage" class="gm-inbox-creative creative-missing">{{ missingDimensionLabel }}</div>
        </a>
      </div>

      <div class="gm-inbox-actions d-flex flex-column align-items-end">
        <i class="bi bi-three-dots-vertical"></i>
        <i class="bi bi-box-arrow-up-right"></i>
      </div>
    </div>
    <!-- END: Real ad -->

    <div class="gm-inbox-row d-flex flex-row" *ngFor="let row of inboxSkeletonRows">
      <span class="gm-inbox-row-avatar placeholder"></span>
      <div class="gm-inbox-row-lines d-flex flex-column">
        <span class="gm-inbox-row-bar gm-inbox-row-bar-short placeholder"></span>
        <span class="gm-inbox-row-bar gm-inbox-row-bar-mid placeholder"></span>
        <span class="gm-inbox-row-bar placeholder"></span>
      </div>
    </div>
  </div>

  <div frameBottom class="gm-inbox-bottomnav d-flex flex-row justify-content-around align-items-center">
    <span class="gm-inbox-bottomnav-btn"><i class="bi bi-envelope"></i></span>
    <i class="bi bi-chat-square"></i>
    <i class="bi bi-camera-video"></i>
  </div>
</app-mobile-frame>
